import Config from "../../common/model/Config";
import GlobalVar from "../../common/model/GlobalVar";
import Provider from "../model/Provider";
import { providerChk } from "../utils/provider.id.check";

var rootId = "";
var pcMobileId = "";
export const commonEvent = {
    init(){
        rootId = Config.appendElementTagId;
        pcMobileId = GlobalVar.pcMobileId;

        commonEvent.serviceChangeEvent();
    },
    serviceChangeEvent(){
        //서비스 선택
        $(`${rootId} ${pcMobileId} .oacx_providerList li`).on("click", (e) => {
            Provider.providerId = $(e.currentTarget).find("input[name=provider]").val();
            // 통신사 패스 선택에 따라 UI 화면 변경
            if (providerChk.isPass(Provider.providerId)) {
                commonEvent.setTelcoSelect();
                commonEvent.setTelcoInput();
                $(`${rootId} ${pcMobileId} .none-telecom input[data-id='oacx_phone2']`).off('focusout')
                $(`${rootId} ${pcMobileId} .telecom input[data-id='oacx_phone3']`).on('focusout')

            }else {
                commonEvent.setNoneTelcoSelect();
                commonEvent.setNoneTelcoInput();
                $(`${rootId} ${pcMobileId} .telecom input[data-id='oacx_phone3']`).off('focusout')
                $(`${rootId} ${pcMobileId} .none-telecom input[data-id='oacx_phone2']`).on('focusout')
            }
        });
        // 통신사패스에 선택 시 UI변화에 따른 데이터 입력 유지 이벤트
        $(`${rootId} ${pcMobileId} .none-telecom input[data-id='oacx_phone2']`).on('focusout', (e)=>{
            commonEvent.setTelcoInput();
        })
        $(`${rootId} ${pcMobileId} .none-telecom select[data-id='oacx_phone1']`).on("change", (e) => {
            commonEvent.setTelcoSelect();
        })

        // 통신사패스에 선택 시 UI변화에 따른 데이터 입력 유지 이벤트
        $(`${rootId} ${pcMobileId} .telecom input[data-id='oacx_phone3']`).on('focusout', (e)=>{
            commonEvent.setNoneTelcoInput();
        })
        $(`${rootId} ${pcMobileId} .telecom select[data-id='oacx_phone1']`).on("change", (e) => {
            commonEvent.setNoneTelcoSelect();
        })
    },
    setNoneTelcoSelect(){
        const telecomPhone1 = $(`${rootId} ${pcMobileId} .telecom select[data-id='oacx_phone1']`).val();
        $(`${rootId} ${pcMobileId} .none-telecom select[data-id='oacx_phone1'] option[value=${telecomPhone1}]`).prop("selected",true);
    },
    setNoneTelcoInput(){
        const telecomPhone2 = $(`${rootId} ${pcMobileId} .telecom input[data-id='oacx_phone3']`).val();
        $(`${rootId} ${pcMobileId} .none-telecom input[data-id='oacx_phone2']`).val(telecomPhone2);
    },
    setTelcoSelect(){
        const telecomPhone1 = $(`${rootId} ${pcMobileId} .none-telecom select[data-id='oacx_phone1']`).val();
        $(`${rootId} ${pcMobileId} .telecom select[data-id='oacx_phone1'] option[value=${telecomPhone1}]`).prop("selected",true);
    },
    setTelcoInput(){
        const telecomPhone2 = $(`${rootId} ${pcMobileId} .none-telecom input[data-id='oacx_phone2']`).val();
        $(`${rootId} ${pcMobileId} .telecom input[data-id='oacx_phone3']`).val(telecomPhone2);
    }
}